import apiClient from './config';

const pointsApi = {
  // Get user points
  getUserPoints: async () => {
    try {
      const response = await apiClient.get('/points');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get points history
  getPointsHistory: async (params = {}) => {
    try {
      const response = await apiClient.get('/points/history', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Redeem points
  redeemPoints: async (redeemData) => {
    try {
      const response = await apiClient.post('/points/redeem', redeemData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get customer point history
  getCustomerPointHistory: async () => {
    try {
      const response = await apiClient.get('/customer-point-history', {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get customer point history
  getCustomerRedeemProduct: async () => {
    try {
      const response = await apiClient.get('/customer-redeem-product', {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get customer info (including points)
  getCustomerInfo: async () => {
    try {
      const response = await apiClient.get('/customer-info', {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Redeem product with points
  redeemProduct: async (redeemData) => {
    try {
      const response = await apiClient.post('/customer-redeem-product', redeemData, {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default pointsApi; 